import React from 'react'
import { FooterProps } from './types'
import LinkConverter from '../LinkConverter'
import LogoColumn from './components/LogoColumn'
import InformationColumn from './components/InformationColumn'
import NewsletterColumn from './components/NewsletterColumn'
import BottomFooterSection from './components/BottomFooterSection'

// MUI
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { grey } from '@mui/material/colors'

const Footer = ({ mainLinks, bottomLinks }: FooterProps) => {
  const styles = {
    root: {
      backgroundColor: grey[100],
    },
    titles: {
      marginBottom: '16px',
    },
    linkList: {
      '& .MuiListItem-root': {
        padding: `0 0 14px 0`,
      },
      '& .MuiLink-root': {
        color: 'common.black',
        '&:hover': {
          color: 'primary.main',
        },
      },
    },
  }
  const hidden = useMediaQuery(useTheme().breakpoints.down('lg'))

  return (
    <Box component="footer" sx={styles.root} pt={8} pb={6}>
      <Container>
        <LogoColumn />
        <Grid spacing={4} justifyContent="space-between" container>
          <InformationColumn />
          {hidden && <NewsletterColumn />}

          {mainLinks.map((menus, index: number) => {
            return (
              <Grid item key={index} xs={12} md={6} lg={mainLinks.length === index + 1 ? 3 : 2}>
                <Typography component="h2" sx={styles.titles} variant="subtitle1">
                  {menus.title}
                </Typography>
                <List sx={styles.linkList} disablePadding>
                  {menus.links.map(({ href, title, linkText, tooltip }, index: number) => {
                    return (
                      <ListItem key={index}>
                        {href && (
                          <LinkConverter linkHref={href} linkTitle={title} isTooltip={tooltip}>
                            {linkText}
                          </LinkConverter>
                        )}
                      </ListItem>
                    )
                  })}
                </List>
              </Grid>
            )
          })}
          {!hidden && <NewsletterColumn />}
        </Grid>
        <BottomFooterSection links={bottomLinks} />
      </Container>
    </Box>
  )
}

export default Footer
